import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';
import {genericMandarkRequest} from 'resources/mandark.resource';

import {GlobalAssignmentsSharedOptions} from '../constants';

export const getDraftGlobalAssignmentsQuery = ({
  name = '',
  sortOption = 'updated_at',
  page = 1,
  classes = []
}) =>
  resource('draft_assignments_v1')
    .mandarkEndpoint(['draft_assignments_v1'])
    .include('teacher_v1')
    .include('classrooms_v1.teachers_v1')
    .include('question_sets_v1.questions_v3') // added to get access to question's status
    .meta({
      context: {
        assignment: {
          stats: true
        },
        default: {
          settings: true
        },
        user: {
          id: masqueradeStore.getUserIdByMasqueradeState()
        }
      }
    })
    .filter({
      teacher_v1: masqueradeStore.getUserIdByMasqueradeState()
    })
    .filter(
      {
        name: {case_insensitive_substring: name}
      },
      !!name
    )
    .page(page)
    .filter(
      {
        classrooms_v1: {
          id: classes.join(',')
        }
      },
      classes.length > 0
    )
    .sort(sortOption);

export const getPublishedGlobalAssignmentsQuery = ({
  name = '',
  sortOption = 'updated_at',
  page = 1,
  status = '',
  classes = [],
  shared = '',
  isAdmin = false
}) =>
  resource('assignments_v3')
    .mandarkEndpoint(['assignments_v3'])
    .include('classrooms_v1.teachers_v1')
    .include('teacher_v1')
    .withMeta('assignment_v3')
    .meta({
      context: {
        assignment: {
          stats: true
        },
        default: {
          settings: true
        },
        user: {
          id: masqueradeStore.getUserIdByMasqueradeState(),
          is_creator_or_classroom_teacher: true
        },
        is_open: true,
        is_scheduled: true,
        is_closed: true
      }
    })
    .filter({
      'meta.user_is_creator_or_classroom_teacher': true
    })
    .filter({
      included: {
        classrooms_v1: {
          ...(!isAdmin
            ? {teachers_v1: masqueradeStore.getUserIdByMasqueradeState()}
            : {
                school_v5: {
                  school_personnel_v1: {
                    teacher_v1: {
                      id: masqueradeStore.getUserIdByMasqueradeState()
                    },
                    role_v1: {
                      name: {
                        not: 'teacher'
                      }
                    },
                    status: 'approved'
                  }
                }
              })
        }
      }
    })
    .filter(
      {
        teacher_v1: {
          id: masqueradeStore.getUserIdByMasqueradeState()
        }
      },
      shared === GlobalAssignmentsSharedOptions[0]
    )
    .filter(
      {
        all_of: [
          {
            classrooms_v1: {
              teachers_v1: {
                id: masqueradeStore.getUserIdByMasqueradeState()
              }
            }
          },
          {
            teacher_v1: {
              id: {
                not: masqueradeStore.getUserIdByMasqueradeState()
              }
            }
          }
        ]
      },
      shared === GlobalAssignmentsSharedOptions[1]
    )
    .filter(
      {
        name: {case_insensitive_substring: name}
      },
      !!name
    )
    .page(page)
    .filter(
      {
        'meta.is_open': true
      },
      status === 'open'
    )
    .filter(
      {
        'meta.is_scheduled': true
      },
      status === 'scheduled'
    )
    .filter(
      {
        'meta.is_closed': true
      },
      status === 'closed'
    )
    .filter(
      {
        classrooms_v1: {
          id: classes.join(',')
        }
      },
      classes.length > 0
    )
    .sort(sortOption);

export const getClassesQuery = ({includeArchived = false, page = 1, isTeacher = false}) =>
  resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', masqueradeStore.getUserIdByMasqueradeState(), 'classrooms_v1'])
    .include('teachers_v1')
    .withMeta('classroom_v1')
    .filter(
      {
        any_of: [
          {
            status: 'active'
          },
          {
            status: 'archived'
          }
        ]
      },
      includeArchived
    )
    .filter(
      {
        status: 'active'
      },
      !includeArchived
    )
    .filter(
      {
        teachers_v1: {
          school_personnel_v1: {
            status: 'approved'
          }
        }
      },
      !isTeacher
    )
    .page(page)
    .sort('name');

export const handleDeleteAssignment = async ({assignmentId, isDraft}) => {
  const deleteQuery = {
    resourcePath: [isDraft ? 'draft_assignments_v1' : 'assignments_v3', assignmentId]
  };
  await genericMandarkRequest('delete', deleteQuery);
};
